import cuid from "cuid";
import { get } from "lodash";
import { useCallback, useEffect, useRef } from "react";
import View from "./View";

const getInitialStatus = (tracer) =>
  get(tracer, "flow.process.processStatuses", []).reduce((previous, current) =>
    Number(previous?.order) < Number(current.order) ? previous : current,
  );

const DuplicateDrawer = ({
  open,
  project,
  onClose,
  duplicate,
  setTracer,
  tracers,
}) => {
  const autoDuplicateStartedRef = useRef(false);

  const onDuplicateToTracer = useCallback(
    (targetTracer) => {
      if (!project) return;

      const status = getInitialStatus(targetTracer);
      const sourceFields = get(project, "fields", {});

      setTracer(targetTracer);
      duplicate({
        variables: {
          where: { id: project.id },
          data: {
            visible: true,
            tracer: { id: get(targetTracer, "id") },
            fields: {
              ...sourceFields,
              processTemplate: get(targetTracer, "flow.process.theme"),
              currentDevisCombinationKeys: undefined,
              consumedCombinations: undefined,
              combinations: undefined,
              upsells: undefined,
              lastSelected: undefined,
              insurancePlans: undefined,
              quoteNumber: undefined,
              graCode: undefined,
              hasUpsells: undefined,
              currentSubscription: undefined,
              subscriptions: undefined,
              quotedPlans: undefined,
              nextQuoteStatus: undefined,
            },
            statuses: [
              {
                id: cuid(),
                status: { id: get(status, "id") },
              },
            ],
          },
        },
      });
      onClose();
    },
    [project, duplicate, setTracer, onClose],
  );

  useEffect(() => {
    if (!open) {
      autoDuplicateStartedRef.current = false;
      return;
    }

    if (!project || tracers.length !== 1 || autoDuplicateStartedRef.current) {
      return;
    }

    autoDuplicateStartedRef.current = true;
    onDuplicateToTracer(tracers[0]);
  }, [open, project, tracers, onDuplicateToTracer]);

  if (tracers.length <= 1) {
    return null;
  }

  return (
    <View
      onClose={onClose}
      open={open}
      tracers={tracers}
      onDuplicateToTracer={onDuplicateToTracer}
    />
  );
};

export default DuplicateDrawer;
